import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import SiteHeader from '../../includes/SiteHeader';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import { AccountListComponent } from '../common/AccountListComponent';
import { SavingPotsLanding } from './SavingPotsLanding';
import config from '../../config';
import { BasicModal } from '../common/modals/BasicModal';
import AccountsStore from '../../stores/AccountsStore';
import AccountsActionCreator from '../../actions/AccountsActionCreator';
import SavingsPotsStore from '../../stores/SavingsPotsStore';
import SavingPotsActionCreator from '../../actions/SavingPotsActionCreator';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import AnalyticsActionCreator from '../../actions/AnalyticsActionCreator';
import AnyQuestions from '../help/AnyQuestions';
import BrowserUtils from '../../utils/BrowserUtils';
import LoaderComponent from '../common/LoaderComponent';
import OrientationSwitch from '../common/OrientationSwitch';
import InternetBankingActions from '../../actions/InternetBankingActions';

let potPage;

function getStateFromStores() {
  return {
    accountsList: AccountsStore.getAll(),
    checkpotFlag: SavingsPotsStore.checkpotFlag(),
    potData: SavingsPotsStore.getPotData(),
    getClickedAccount: SavingsPotsStore.getClickedAccount(),
    selectedAccountID: SavingsPotsStore.getSelectedAccountID(),
    accountIndex: SavingsPotsStore.getAccountIndex(),
    isCreatePage: SavingsPotsStore.getCreateSavingPotPage(),
    isPotDetailsPage: SavingsPotsStore.getPotDetailsFlag(),
    getPotDetailsData: SavingsPotsStore.getPotDetailsData(),
    getReducePotData: SavingsPotsStore.getReducePotPage(),
    getPotConfirmation: SavingsPotsStore.getPotConfirmationFlag(),
    editError: SavingsPotsStore.editError(),
    potError: SavingsPotsStore.potError(),
    displayLoading: SavingsPotsStore.displayLoading(),
    unavailableCheck: SavingsPotsStore.unavailableCheck(),
    interPotError: SavingsPotsStore.interPotError(),
    isNetworkError: SavingsPotsStore.isNetworkError(),
    faqFlag: false,
    rejigDoneFlag: SavingsPotsStore.rejigDoneFlag(),
    checkCurrentAccFlag: false,
  };
}

class SavingPotsPage extends Component {
  constructor(props) {
    super(props);

    this._getAccountList = this._getAccountList.bind(this);
    this._getPotPage = this._getPotPage.bind(this);
    this._onStoreChange = this._onStoreChange.bind(this);
    this._reload = this._reload.bind(this);
    this.backToAccountPage = this.backToAccountPage.bind(this);
    this.closeFaq = this.closeFaq.bind(this);
    this.openFaq = this.openFaq.bind(this);
    this.savingpostsPageView = this.savingpostsPageView.bind(this);

    this.state = getStateFromStores();
  }

  componentWillMount() {
    // SavingsPotsStore.getSelectedHeadAccount();
    // SavingPotsActionCreator.getAccountsList();
    // AccountsActionCreator.getAccountsList();

    this.setState({
      checkCurrentAccFlag: SavingsPotsStore.getCurrentAccountFlag(),
    });

    BrowserUtils.setViewPort(1);
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description: config.analytics.analytics_name_saving_goal_account_list,
        event: 'click',
      }
    );
  }

  componentDidMount() {
    AccountsStore.addChangeListener(this._onStoreChange);
    SavingsPotsStore.addChangeListener(this._onStoreChange);
    sayLandingMessage('Saving Pots');
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/view',
        action: 'Appeared',
      },
      {
        description: 'PageLoaded',
      }
    );
  }

  componentWillUnmount() {
    AccountsStore.removeChangeListener(this._onStoreChange);
    SavingsPotsStore.removeChangeListener(this._onStoreChange);
    SavingsPotsStore.resetFlags();
  }

  // Get Account List
  _getAccountList() {
    return (
      <AccountListComponent
        savingPot
        accountList={this.state.accountsList}
        stepChange={this.stepChange}
        content={this.props.content}
      />
    );
  }

  _getPotPage() {
    SavingPotsActionCreator.getPotData();
  }

  // Callback
  _onStoreChange() {
    this.setState(getStateFromStores());
    this.setState({
      checkCurrentAccFlag: SavingsPotsStore.getCurrentAccountFlag(),
    });
  }

  _reload() {
    AccountsActionCreator.getAccountsList();
    SavingPotsActionCreator.getPotData();
    this.setState({ isNetworkError: false });
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description: config.analytics.analytics_name_saving_goal_account_list,
        event: 'click',
      }
    );
  }

  backToAccountPage(e) {
    e.preventDefault();
    InternetBankingActions.navigateToWebTask(
      SavingsPotsStore.getNavigationReference()
    );
  }

  closeFaq() {
    this.setState({ faqFlag: false });
  }

  openFaq() {
    this.setState({ faqFlag: true });
  }

  savingpostsPageView() {
    const checkpotFlag = this.state.checkpotFlag;
    const content = this.props.content;
    const isNetworkError = this.state.isNetworkError;
    const unavailableCheck = this.state.unavailableCheck;
    let headerContent;
    let confirmPageCSS = ' ';
    if (this.state.rejigDoneFlag) {
      potPage = (
        <div>
          {' '}
          {headerContent}
          <div className="main-container">
            {/* <div className="spinner-loader">
						<div className="spinner">
							<SvgIcon id="icon-refresh" width="200px" height="200px"/>
						</div>
					</div> */}
            <LoaderComponent type="large" />
          </div>
        </div>
      );
    } else if (this.state.checkCurrentAccFlag) {
      potPage = (
        <div>
          <div className="main-container">
            <div className="sp-msg">
              {content.savingpotNoSavingAccount1}
              <br />
              <br />
              {content.savingpotNoSavingAccount2}
            </div>
          </div>
        </div>
      );
    } else if (
      this.state.accountsList &&
      !this.state.displayLoading &&
      !isNetworkError
    ) {
      if (checkpotFlag || unavailableCheck) {
        let potData = this.state.potData;
        potPage = (
          <SavingPotsLanding
            {...this.props}
            pots={potData}
            accountList={this._getAccountList()}
            accountIndex={this.state.accountIndex}
            createSavingPotFlag={this.state.isCreatePage}
            getPotPageHandleClick={this._getPotPage}
            potDetailFlag={this.state.isPotDetailsPage}
            potDetailsData={this.state.getPotDetailsData}
            reducePotData={this.state.getReducePotData}
            getPotConfirmation={this.state.getPotConfirmation}
            content={content}
            getSelectedAccountID={this.state.selectedAccountID}
            editError={this.state.editError}
            potError={this.state.potError}
            interPotError={this.state.interPotError}
            unavailableCheck={this.state.unavailableCheck}
            getClickedAccount={this.state.getClickedAccount}
          />
        );
      }
    } else if (isNetworkError) {
      potPage = (
        <div>
          <div className="main-container">
            <BasicModal>
              <div className="modal_content">
                <h3>{this.props.content.OTPAuthenticationTitleNoOTP}</h3>
              </div>
              <div className="modal_footer">
                <button onClick={this._reload}>{this.props.content.ok}</button>
              </div>
            </BasicModal>
          </div>
        </div>
      );
    } else {
      if (!BrowserUtils.isMobileView()) {
        headerContent = <SiteHeader />;
      } else {
        headerContent = '';
      }
      potPage = (
        <div>
          <div className="main-container">
            {/* <div className="spinner-loader">
            <div className="spinner">
              <SvgIcon id="icon-refresh" width="200px" height="200px"/>
            </div>
				  </div> */}
            <LoaderComponent type="large" />
          </div>
        </div>
      );
    }
    if (this.state.getPotConfirmation) {
      confirmPageCSS = 'create-success';
    }
    return this.state.faqFlag ? (
      <div>
        <AnyQuestions {...this.props} closed={this.closeFaq} />
      </div>
    ) : (
      <div
        className={`b container-fluid-full savingpots scrollable ${confirmPageCSS}`}
      >
        <Helmet title="Savings Pots" />
        {potPage}
      </div>
    );
  }

  render() {
    return (
      <OrientationSwitch
        backToAccountPage={this.backToAccountPage}
        view={this.savingpostsPageView}
      />
    );
  }
}

SavingPotsPage.propTypes = {
  content: PropTypes.object,
};

const SavingsPotsPageWithAuth = RequiresAuthenticatedUser(SavingPotsPage);

export { SavingsPotsPageWithAuth as SavingPotsPage };
